export enum Routes {
  'BASE' = '/complaint-book',
  'HOME' = '',
  'COMPLAINT' = 'register',
  'SELECT_COUNTRY' = '/complaint-book/countries',
  'COMPLAINT_SUCCESS' = 'register/:claimId/:claimGUID/success',
  'PRIVACY' = '/complaint-book/privacy',
}
